import React, {useState, useEffect} from 'react';
import {Button, Col, Modal, Table, Row} from "antd";
import '../modals.css';
import {YMaps, Map, SearchControl, Placemark, Polyline} from "react-yandex-maps";
import { useRef } from 'react';
import Spinner from '../../spinner';
import i18n from '../../../i18n'

function MapLocation() {
    this.country = "Россия";
    this.countryId = 1;
    this.address = "";
    this.lat = "";
    this.lon = "";
}

export default function MapPointSelectModal({isShow, setIsShow, countryList, pointGuid, updatePoint}) {
    const [searchControl, setSearchControl] = useState(null);
    const yMap = useRef(null);
    const [placeMark, setPlaceMark] = useState(null);
    const [mapLocation, setMapLocation] = useState(null);

    const [pinPlace, setPinPlace] = useState(null);

    const [mapLoad, setMapLoad] = useState(false);


    let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', borderColor: 'transparent', boxShadow: 'none' };


    const handleMapClick = async (event) => {
        const coords = event.get('coords'); // Получаем координаты клика
        console.log('Клик по карте в координатах:', coords);
        if (yMap.current) {
            try {
                const result = await yMap.current.geocode(coords);
                const firstGeoObject = result.geoObjects.get(0);
                if (firstGeoObject) {
                    makeMapLocation(firstGeoObject);
                }
            } catch (error) {
                console.error('Error during geocoding:', error);
            }
        }
    };

    const makeMapLocation  = (point) => {
        let country = (countryList.find(x => x.Name === point.getCountry()));

        let coords = point.geometry.getCoordinates();

        if(point && coords) {
            let mapLoc = new MapLocation();

            mapLoc.address = point.getAddressLine();
            mapLoc.lat = coords[0];
            mapLoc.lon = coords[1];

            if(country) {
                mapLoc.country = country.Name;
                mapLoc.countryId = country.Id;
            }

            setPinPlace(coords);
            setMapLocation(mapLoc);
        }
    }

    const onResultShow = () => {
        if (searchControl) {

            let selectedIndex = searchControl.getSelectedIndex();
            let searchResults = searchControl.getResultsArray();
            let selectedPoint = searchResults[selectedIndex];

            makeMapLocation(selectedPoint);
        }
    };

    const onConfirmAddress = () => {
        if(!mapLocation) {
            return false;
        }

        updatePoint('country', mapLocation.country, pointGuid);
        updatePoint('countryId', mapLocation.countryId, pointGuid);
        updatePoint('address', mapLocation.address, pointGuid);
        updatePoint('lat', mapLocation.lat, pointGuid);
        updatePoint('lon', mapLocation.lon, pointGuid);

        setMapLocation(null);
        setPinPlace([0,0]);
        searchControl.clear();
        setIsShow(false);
    }

    return (
        <Modal
            title={<span className="ant-modal-title">{i18n.t('modals.mapPointSelectModal.title')}</span>}
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            style={{maxWidth: '450px'}}
            align={null}
            visible={isShow}
            onCancel={() => {
                setIsShow(false);
            }}
            footer={null}
        >
            <Spinner loading={!mapLoad} tin={i18n.t('main.loadText.loading')}>
                <Row gutter={[16, 24]} style={{marginBottom: "34px", minHeight: '300px'}}>
                    <Col span={24}>
                        <YMaps
                            query={{
                                ns: "use-load-option",
                                load: 'package.full',
                                //load: "Map,Placemark,control.SearchControl,control.ZoomControl,control.FullscreenControl",
                                style: {
                                    width: "1000",
                                    height: "500",
                                },
                                apikey: '9133eb49-3a97-4b2d-90be-6b80a97a5036',
                                suggest_apikey: '9060729f-e2ae-45a8-8177-352d7cfb5a85'
                            }}
                        >
                            <Map
                                instanceRef={yMap}
                                defaultState={{
                                    center: [63.791765, 98.121231],
                                    zoom: 3,
                                    controls: ["zoomControl", "fullscreenControl"],
                                }}
                                onClick={handleMapClick}
                                onLoad={(ymaps) => {
                                    setMapLoad(true)
                                    yMap.current = ymaps;
                                }}
                                width={"100%"}
                                height={"300px"}
                            >
                                <SearchControl
                                    instanceRef={ref => setSearchControl(ref)}
                                    options={{
                                        noSuggestPanel: true,
                                        noPlacemark: true,
                                        searchControlMaxWidth: [30, 72, 500],
                                        fitMaxWidth: true,
                                    }}
                                    onResultShow={onResultShow} />
                                <Placemark
                                    key={'myMark'}
                                    geometry={pinPlace}
                                    instanceRef={ref => setPlaceMark(ref)}
                                />
                            </Map>
                        </YMaps>
                    </Col>
                </Row>
            </Spinner>
            {mapLocation && <Row gutter={[16, 24]}>
                <Col lg={24} md={24} sm={24} sx={24} style={{ textAlign: 'left'}}>
                    <p>{i18n.t('modals.mapPointSelectModal.fields.address.title')}: {mapLocation.address}</p>
                    <p>{i18n.t('modals.mapPointSelectModal.fields.lat.title')}: {mapLocation.lat}</p>
                    <p>{i18n.t('modals.mapPointSelectModal.fields.lon.title')}: {mapLocation.lon}</p>
                </Col>
            </Row>}
            <Row gutter={[16, 24]}>
                <Col lg={24} md={24} sm={24} sx={24} style={{ textAlign: 'center' }}>
                <Button
                    type="primary"
                    size="large"
                    htmlType="button"
                    onClick={onConfirmAddress}
                    disabled={!mapLocation}
                    style={{ margin: '0 5px 10px 0', ...bigButtonStyle }}
                >
                  {i18n.t('modals.mapPointSelectModal.buttons.confirm')}
                </Button>
                </Col>
            </Row>
        </Modal>
    );
}
